export default __webpack_public_path__ + "static/media/organization-icon.80e80f15.svg";